import { CommonModule } from '@angular/common';
import { Component, output, ViewChild, inject, signal, effect, input, computed } from '@angular/core';
import { PopoverModule } from 'primeng/popover';
import { Popover } from 'primeng/popover';
import { YearAcademy } from '../../../core/services/year-academy/types';
import { NavbarStore } from '../layout/navbar/dropdown-profile/store/navbar.store';

@Component({
  selector: 'app-select-school-year',
  imports: [CommonModule, PopoverModule],
  templateUrl: './select-school-year.html',
  styleUrl: './select-school-year.scss',
  standalone: true
})
export class SelectSchoolYear {
  private readonly navbarStore = inject(NavbarStore);
  readonly isLoading = this.navbarStore.isLoading;
  options = this.navbarStore.yearsAcademy;

  useGlobal = input<boolean>(true);
  initialOption = input<YearAcademy | null>(null);
  private localSelected = signal<YearAcademy | null>(null);

  selectedOption = computed(() => this.useGlobal() ? this.navbarStore.selectedYearAcademy() : this.localSelected());

  yearChanged = output<YearAcademy>();

  @ViewChild('schoolYearMenu') schoolYearMenu!: Popover;

  toggleDropdown(event: Event) {
    if (this.schoolYearMenu) {
      this.schoolYearMenu.toggle(event);
    }
  }

  selectOption(option: YearAcademy) {
    if (this.useGlobal()) {
      this.navbarStore.selectedYearAcademy.set(option);
    } else {
      this.localSelected.set(option);
    }
    this.yearChanged.emit(option);
    if (this.schoolYearMenu) {
      this.schoolYearMenu.hide();
    }
  }

  constructor() {
    effect(() => {
      if (!this.useGlobal()) {
        const initial = this.initialOption() ?? this.navbarStore.selectedYearAcademy();
        if (initial && (!this.localSelected() || this.localSelected()?.id !== initial.id)) {
          this.localSelected.set(initial);
        }
      }
    });
  }
}